import { connect } from 'react-redux';

import {
  getCustomSync,
  setCustomSyncMessage,
  updateCustomSync,
} from '../../actions/accountSettingsAction';
import {
  getCustomSyncMessageSelector,
  getCustomSyncSelector,
  getIsLoadingCustomSyncDataSelector,
  getIsLoadingCustomSyncSelector,
} from '../../components/AccountSettings/AccountSettingsSelectors';
import CustomSyncView from '../../components/AccountSettings/CustomSync/CustomSyncView';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state) => ({
  customSync: getCustomSyncSelector(state),
  customSyncMessage: getCustomSyncMessageSelector(state),
  isLoadingCustomSync: getIsLoadingCustomSyncSelector(state),
  isLoadingCustomSyncData: getIsLoadingCustomSyncDataSelector(state),
  user: getUser(state),
});

const mapDispatchToProps = (dispatch) => ({
  getCustomSync: () => dispatch(getCustomSync()),
  updateCustomSync: (customSync) => dispatch(updateCustomSync(customSync)),
  setCustomSyncMessage: (message) => dispatch(setCustomSyncMessage(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomSyncView);
